import { render } from "./FaceManipulation.vue?vue&type=template&id=6549ac52"
import script from "./FaceManipulation.vue?vue&type=script&lang=js"
export * from "./FaceManipulation.vue?vue&type=script&lang=js"

import "./FaceManipulation.vue?vue&type=style&index=0&id=6549ac52&lang=scss"
script.render = render

export default script